import { connect } from 'react-redux';
import { setLangSelected } from '../../actions';
import LangSelector from './LangSelector';

const mapStateToProps = ({ scribeConversation: { speechLang, availableLangs } }) => ({
  speechLang,
  availableLangs,
});

export default connect(mapStateToProps, {
  setLangSelected,
})(LangSelector);
